import {
    Nav,
    NavDropdown,
    Carousel,
    Container,
    Form,
    Button,
    Modal,
    Col,
    Row,
    ListGroup,
    Image,
    NavItem,
    NavLink,
  } from "react-bootstrap";
  import React, { Link, useParams, useHistory } from "react-router-dom";
  import { useEffect, useState } from "react";
 
  import {
    getAllCategories,
    searchProductInCityCategory,
  } from "../../services/api";
  import "./styles.scss";
  import ProductCard from "../../components/ProductCard";
  import Loader from "../../components/Loader/Loader";
  import { GoChevronDown } from "react-icons/go";
  import { BiSortDown, BiSortUp } from "react-icons/bi";
  import LoadingIndicator from "../../components/LoadingIndicator";
  import Footer from "../../components/Footer";
  import debounce from "lodash.debounce";
  
  import PaginationComponent from "../../components/Pagination";
  import { Helmet } from "react-helmet";
  import { textEllipsis } from "../../utils/mappers";
  import qs from "qs";
  import {useSearch } from '../../contexts/SearchContext'
  export default function Marketplace({ match, location }) {
    const [categorySelected, setCategorySelected] = useState("Todas as categorias");
    const { debouncedSearchTerm } = useSearch();
    const [showAll, setShowAll] = useState(false);
    const [page, setPage] = useState();
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);
    const [status, setStatus] = useState("loading");
    const navigate = useHistory();
    const { idCategory } = useParams();
    const { subCat } = useParams();
    const [lastCategory, setLastCategory] = useState(idCategory);
    const [selectedSubCategory, setSelectedSubCategory] = useState(subCat);
    const [categories, setCategories] = useState([]);
    const [ascOrDesc, setAscOrDesc] = useState("DESC");
    const [highlights, setHighlights] = useState(null);
    const [loadingHighlights, setLoadingHighlights] = useState(true);
    const q = qs.parse(location.search, { ignoreQueryPrefix: true }).q;
   
    const handleCategorySelect = (id, isSubCategory, path) => {
      
      navigate.push(path);  // Ajuste para v6
  
     
          setLastCategory(id);
       
      
  };
  const resetSelection = () => {
    setLastCategory(null);
  
    navigate.push('/produtos');

};
    
    useEffect(() => {
      const p = sessionStorage.getItem("@app_mercadim:p");
      if (p) {
        setPage(Number(p));
      }
    }, []);
    useEffect(() => {
      getAllCategories().then((data) => {
        setCategories(data);
      });
    }, []);
    useEffect(() => {
      if (selectedSubCategory !== subCat) {
        setSelectedSubCategory(subCat);
      setPage(0); // Reinicia a paginação
      setResults([]); // Limpa os resultados existentes
      setStatus("loading");
      }
    }, [selectedSubCategory, subCat]);
    useEffect(() => {
      if (lastCategory !== idCategory) {
        setLastCategory(idCategory);
      setPage(0); // Reinicia a paginação
      setResults([]); // Limpa os resultados existentes
      setStatus("loading");
      }
    }, [lastCategory, idCategory]);
    useEffect(() => {
      sessionStorage.setItem("@app_mercadim:q", debouncedSearchTerm);
      setPage(1); // Reinicia a paginação
      setResults([]); // Limpa os resultados existentes
      setStatus("loading");
    }, [debouncedSearchTerm]);
    useEffect(() => {
      if (!q) {
        sessionStorage.setItem("@app_mercadim:p", page);
  
      }
    }, [page, q]);
    const googleAd = {
      imageUrl: "https://via.placeholder.com/300x600", // Substitua pelo link correto da imagem do anúncio
      url: "https://google.com" // Substitua pelo URL do anúncio
    };
    useEffect(() => {
      
      /*setTimeout(async () => {*/
      if (lastCategory) {
  
        const payload = {
          nameProduto: debouncedSearchTerm,
          category_id: lastCategory,
          ...(!showAll),
        };
        
        searchProductInCityCategory(payload, page, ascOrDesc).then((data) => {
          setResults((prev) => {
            // Supondo que cada produto tenha um campo 'id' único
            const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
            return [...prev, ...updatedData];
          });
  
          setStatus("result");
        });
      } else if (selectedSubCategory != null) {
        const payload = {
          category_type_id: selectedSubCategory,
          nameProduto: debouncedSearchTerm,
          ...(!showAll),
        };
       
        searchProductInCityCategory(payload, page, ascOrDesc).then((data) => {
          setResults((prev) => {
            // Supondo que cada produto tenha um campo 'id' único
            const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
            return [...prev, ...updatedData];
          });
          setStatus("result");
        });
      } else {
        setCategorySelected("Categorias");
  
        if (q && debouncedSearchTerm.length === 0) {
          const payload = {
            nameProduto: q,
            category_id: lastCategory,
            ...(!showAll),
          };
          searchProductInCityCategory(payload, page, ascOrDesc).then((data) => {
            setResults((prev) => {
              // Supondo que cada produto tenha um campo 'id' único
              const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
              return [...prev, ...updatedData];
            });
            setStatus("result");
          });
        } else {
          const dados = {
            nameProduto: debouncedSearchTerm,
            category_id: lastCategory,
            ...(!showAll),
          };
          searchProductInCityCategory(dados, page, ascOrDesc).then((data) => {
            setResults((prev) => {
              // Supondo que cada produto tenha um campo 'id' único
              const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
              return [...prev, ...updatedData];
            });
            setStatus("result");
          });
        }
      }
     /*  }, 1500);*/
    }, [lastCategory, selectedSubCategory, page, debouncedSearchTerm, ascOrDesc, showAll, q]);
  
    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    const handleScroll = async () => {
      const nearBottom = window.innerHeight + document.documentElement.scrollTop + 1 >= document.documentElement.scrollHeight;
      if (nearBottom && status === "loading") {
        setStatus("result");  // Atualiza o estado para 'loading' antes de carregar mais dados
        setPage((prev) => prev + 1);
      }
    };
    function renderResults() {
  
      if (status !== "result") {
        return null;
      }
  
      if (results.length === 0) {
        return (
          <>
            <Container>
              <Row>
                <Col className="my-5">
                  <h5 className="text-muted text-center my-5">Sem resultados</h5>
                </Col>
              </Row>
            </Container>
          </>
        );
      }
  
      return (
        <>
          <Container>
            <Row className="">
              {results.map((product, index) => (
               <Col key={index} xs={12} sm={6} lg={4} xl={3} style={{marginBlockEnd:'25px'}}>
                  <ProductCard product={product} />
                </Col>
                
              ))}
             
            </Row>
            <div style={{ margin: "80px" }}></div>
          </Container>
        </>
      );
      
    }
    return (
      <>
        <Helmet title="Caçadores de Ofertas: Marketplace" />
        <div className="marketplace-main-wrapper">
          
        <Container fluid>
        <Row>
          <Col xs={12} lg={3} style={{ backgroundColor: '#f8f9fa' }}>
            <div className="p-3">
              <h3>Categorias</h3>
              <ListGroup>
              <ListGroup.Item  action onClick={() =>resetSelection()}>
                   Todas as Categorias
                  </ListGroup.Item>
                {categories.map((category, index) => (
                  <ListGroup.Item key={index} action onClick={() => handleCategorySelect(category.id, false, `/produtos/${category.id}`)}>
                    {category.name}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
            <Col className=" d-flex align-items-center justify-content-center">
      <a href={googleAd.url} target="_blank" rel="noopener noreferrer">
        <Image src={googleAd.imageUrl} width={'400px'}  alt="Google Ads" fluid />
      </a>
    </Col>
          </Col>
       
          <Col xs={12} lg={9}>
            <div className="p-3">
              <h2>Ofertas</h2>
              <Row>
                {renderResults()}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
        </div>
        <Footer />
      </>
    );
  }
  
  
  
  
  
  